<template>
  <div class="page-main">
    <Head />
    <TSwiper :arrList="arrList" :type = "type" />
    <div >
      <Homepage/>
    </div>
  </div>
</template>

<script setup>
  import Head from '@/components/computer/head.vue'
  import TSwiper from '@/components/computer/Tswiper.vue'
  import Homepage from '@/components/computer/homepage.vue'
  import { useRouter } from 'vue-router'
  import { ref , onMounted} from 'vue'
  import { Swiper } from 'swiper/vue';
  const router = useRouter()
  const type = 1
  const arrList = ref([
    {
        text:'信息化原创性技术软件研发企业',
        text1:'数智展览展示一站式解决方案综合服务商',
        img:require('@/assets/computer/shouye/swiper1.jpg'),
    },{
        text:'信息化原创性技术软件研发企业',
        text1:'数智展览展示一站式解决方案综合服务商',
        img:require('@/assets/computer/shouye/swiper2.jpg'),
    },{
        text:'信息化原创性技术软件研发企业',
        text1:'数智展览展示一站式解决方案综合服务商',
        img:require('@/assets/computer/shouye/swiper3.jpg'),
    },
  ])
  onMounted(() => {

  });

</script>

<style scoped>
@media (min-width:900px) {
  .page-main{
      width: 100%;
      height: 1005;
  }
}
@media only screen and (max-width: 900px) {

}

</style>
